/** What the share sheet hands over (title, text, url) as one capture: a part another part already contains
 *  is left out (apps often repeat the title in the text or the link in both), the link stays last. */
export function sharedText(title: string, text: string, url: string): string {
  const parts = [...new Set([title, text, url].map((x) => x.trim()).filter(Boolean))];
  return parts.filter((p) => !parts.some((q) => q !== p && q.includes(p))).join(" ");
}
